module.exports = __webpack_public_path__ + "static/img/phone.d736d0b4.png";